import {
  faBasketShopping,
  faMinus,
  faPlus,
  faTrash,
  faShoppingBasket,
  faArrowCircleLeft,
  faArrowCircleDown,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { IFood } from "../../../../components/foodCard/food.interface";
import { toggleOutOfServiceModal } from "../../../../redux/slices/appSlice";
import {
  addToCart,
  clearCart,
  decrementQuantity,
} from "../../../../redux/slices/basketSlice";
import { RootState } from "../../../../redux/store";

export const MobileCart = () => {
  const basket = useSelector((state: RootState) => state.basket);
  const navigate = useNavigate();
  const isAuthenticated = useSelector((store: RootState) => store.user.isLogin);
  const dispatch = useDispatch();

  const [showBasket, setShowBasket] = useState(false);

  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );

  const allBasketPrice = useMemo(() => {
    let total = 0;
    basket.cart.forEach((item) => {
      total += item.price * item.quantity;
    });
    return total;
  }, [basket]);

  const handleOnCompleteOrderClick = () => {
    if (basket.cart.length === 0) {
      setShowBasket(false);
      return;
    }
    if (!isAuthenticated) {
      navigate("/signin");
      return;
    }

    if (isAppOutOfService || isOutOfServiceTime) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    navigate("/checkout");
  };

  const onPlusClickHandle = (e: any, food: IFood) => {
    e.stopPropagation();
    if (isAppOutOfService || isOutOfServiceTime) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(addToCart(food));
  };

  const onMinusClickHandle = (e: any, food: IFood) => {
    e.stopPropagation();
    if (isAppOutOfService || isOutOfServiceTime) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(decrementQuantity(food.id));
  };

  const onCartClearClick = () => {
    dispatch(clearCart());
  };

  return (
    <>
      <div
        onClick={() => setShowBasket(true)}
        className={`${
          basket.cart.length > 0 ? "flex" : "hidden"
        } font-bold text-xl fixed bottom-0 right-0 left-0 bg-rose-800 lg:hidden w-full p-2 text-white border-t-2 border-rose-900`}
      >
        <span>
          <FontAwesomeIcon icon={faShoppingBasket} />
        </span>
        <span className='flex-1'>سبد خرید</span>
        <span className='bg-rose-700 px-2 rounded'>
          {new Intl.NumberFormat("fa-IR").format(allBasketPrice)} ریال
        </span>
      </div>
      <div
        className={`${
          showBasket ? "block" : "hidden"
        } fixed top-0 right-0 left-0 w-full h-full lg:hidden z-100 bg-white`}
      >
        <div className='flex flex-col h-full'>
          <div
            className='flex border-b'
            onClick={() => setShowBasket(false)}
          >
            <div className='flex-1 font-bold p-4'>سبد خرید</div>
            <div>
              <button
                className='p-4'
                onClick={onCartClearClick}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
              <button
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div className='flex-1  p-2'>
            {basket.cart.length === 0 && (
              <div className='text-center p-8'>
                <div className='text-8xl text-gray-300'>
                  <FontAwesomeIcon icon={faBasketShopping} />
                </div>

                <div>سبد خرید خالی است</div>
              </div>
            )}

            {basket.cart.map((item: IFood) => (
              <div
                className='p-4 flex border-b'
                key={item.id}
              >
                <div className='flex-1'>
                  <div className='font-bold'>{item.name}</div>
                  <div>
                    {new Intl.NumberFormat("fa-IR").format(item.price)} ریال
                  </div>
                </div>
                <div className='flex'>
                  <span
                    className='bg-rose-900 rounded p-2  text-white h-8 inline-block'
                    onClick={(e) => onPlusClickHandle(e, item)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                  <span className='pt-2 h-8 inline-block w-[32px] text-center'>
                    {item.quantity}
                  </span>
                  <span
                    className='bg-gray-500 rounded p-2  text-white h-8 inline-block'
                    onClick={(e) => onMinusClickHandle(e, item)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className='p-2 border-t'>
            <button
              onClick={handleOnCompleteOrderClick}
              className='px-3 py-1 h-[32px] rounded font-bold bg-rose-900 text-white w-full'
            >
              {basket.cart.length === 0
                ? "بازگشت به منوی سفارش"
                : "تکمیل سفارش"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const Cart = ({ isFromCheckoutPage, deliveryCost = 0 }: any) => {
  const [showSetDiscountCode, setShowSetDiscountCode] = useState(false);
  const basket = useSelector((state: RootState) => state.basket);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );
  const isAuthenticated = useSelector((store: RootState) => store.user.isLogin);
  const [showOrderDetail, setShowOrderDetail] = useState(true);
  const allBasketPrice = useMemo(() => {
    let total = 0;
    basket.cart.forEach((item) => {
      total += item.price * item.quantity;
    });
    return total;
  }, [basket]);

  const vat = useMemo(() => {
    return allBasketPrice * 0.1;
  }, [allBasketPrice]);

  const onCartClearClick = () => {
    dispatch(clearCart());
  };

  const onPlusClickHandle = (e: any, food: IFood) => {
    e.stopPropagation();
    if (isAppOutOfService || isOutOfServiceTime) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(addToCart(food));
  };

  const onMinusClickHandle = (e: any, food: IFood) => {
    e.stopPropagation();
    if (isAppOutOfService || isOutOfServiceTime) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(decrementQuantity(food.id));
  };

  const onDiscountClickHandle = () => {
    setShowSetDiscountCode(true);
  };

  return (
    <div className='bg-white border sticky top-4'>
      <div className='flex p-2 font-bold border-b border-solid'>
        <span className='flex-1'>سبد خرید</span>

        {!isFromCheckoutPage && (
          <span
            className={`${basket.cart.length === 0 && "hidden"}`}
            onClick={onCartClearClick}
          >
            <FontAwesomeIcon icon={faTrash} />
          </span>
        )}
      </div>

      <div
        className='flex lg:hidden p-2 font-bold border-b border-solid cursor-pointer'
        onClick={() => setShowOrderDetail((prev) => !prev)}
      >
        <span className='flex-1'>
          <FontAwesomeIcon
            className='ml-2 animate-pulse'
            icon={showOrderDetail ? faArrowCircleDown : faArrowCircleLeft}
          />
          لیست سفارش
        </span>
      </div>

      {basket.cart.length > 0 && (
        <>
          <div className={`${showOrderDetail ? "block" : "hidden"} lg:block`}>
            {basket.cart.map((item: IFood) => (
              <div
                className='p-4 flex border-b'
                key={item.id}
              >
                <div className='flex-1'>
                  <div className='font-bold'>{item.name}</div>
                  <div>
                    {new Intl.NumberFormat("fa-IR").format(item.price)} ریال
                  </div>
                </div>
                <div className='flex'>
                  <span
                    className='bg-rose-900 rounded p-2  text-white h-8 inline-block'
                    onClick={(e) => onPlusClickHandle(e, item)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                  <span className='pt-2 h-8 inline-block w-[32px] text-center'>
                    {item.quantity}
                  </span>
                  <span
                    className='bg-gray-500 rounded p-2  text-white h-8 inline-block'
                    onClick={(e) => onMinusClickHandle(e, item)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div
            className={`p-2  ${
              !isFromCheckoutPage && "text-lg font-bold"
            } border-b`}
          >
            <div className='flex py-2'>
              <div>مجموع</div>
              <div className='flex-1 h-[1px] bg-gray-200 mt-[10px] mx-2'></div>
              <div>
                {new Intl.NumberFormat("fa-IR").format(allBasketPrice)} ریال
              </div>
            </div>
            {isFromCheckoutPage && (
              <>
                <div className='flex py-2'>
                  <div> مالیات بر ارزش افزوده</div>
                  <div className='flex-1 h-[1px] bg-gray-200 mt-[10px] mx-2'></div>
                  <div>{new Intl.NumberFormat("fa-IR").format(vat)} ریال</div>
                </div>

                <div className='flex py-2'>
                  <div>هزینه ارسال </div>
                  <div className='flex-1 h-[1px] bg-gray-200 mt-[10px] mx-2'></div>
                  <div>
                    {new Intl.NumberFormat("fa-IR").format(deliveryCost)} ریال
                  </div>
                </div>

                <div className='text-lg font-bold border-t pt-2 mt-2 text-center'>
                  قابل پرداخت :{" "}
                  {new Intl.NumberFormat("fa-IR").format(
                    deliveryCost + allBasketPrice + vat
                  )}{" "}
                  ریال
                </div>
              </>
            )}
          </div>

          <div className='p-2 font-bold border-b'>
            {!showSetDiscountCode && (
              <div
                className='font-bold'
                onClick={onDiscountClickHandle}
              >
                کد تخفیف دارید؟
              </div>
            )}
            {showSetDiscountCode && (
              <div className='flex'>
                <input
                  type='text'
                  className='flex-1 border rounded'
                />
                <button className='block rounded px-4 mr-1 bg-rose-900 text-white text-center p-2'>
                  ثبت
                </button>
              </div>
            )}
          </div>

          {!isFromCheckoutPage && (
            <div className='p-2'>
              <button
                onClick={() => {
                  if (!isAuthenticated) {
                    navigate("/signin");
                    return;
                  }

                  if (isOutOfServiceTime || isAppOutOfService) {
                    dispatch(toggleOutOfServiceModal());
                    return;
                  }

                  navigate("/checkout");
                }}
                className='block rounded w-full bg-rose-900 text-white text-center p-2'
              >
                تکمیل سفارش
              </button>
            </div>
          )}
        </>
      )}
      {basket.cart.length === 0 && (
        <div className='text-center p-8'>
          <div className='text-8xl text-gray-300'>
            <FontAwesomeIcon icon={faBasketShopping} />
          </div>

          <div>سبد خرید خالی است</div>
        </div>
      )}
    </div>
  );
};

export default Cart;
